// The auth context lives here (not in App.js) so pages and components can read
// the signed-in user without importing App — App.js provides it.
import { createContext, useContext } from 'react';

export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}
